<div id="int-dashboard-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.dashboard.title' | translate">
    <!-- @if (api.hasPermission('create_events')) {
      <reactive-button
        actions
        [label]="'internal.events.newEvent' | translate"
        icon="add"
        variant="outlined"
        (onClick)="editEvent()"
      ></reactive-button>
    } -->
  </app-internal-toolbar>

  <!-- External Links -->
  <div class="max-w-250 w-full p-5 m-auto">
    <nav id="external-links" class="w-full flex flex-row justify-evenly gap-2">
      @for (link of externalLinks; track $index) {
        @if (!link.disabled) {
          <a class="w-full flex flex-row bg-emphasis rounded-sm p-4 hover:bg-highlight transition cursor-pointer" [href]="link.link" target="_blank">
            <mat-icon>{{link.icon}}</mat-icon>
            <span class="ml-2">{{link.name}}</span>
            <mat-icon iconClass="ml-auto text-muted-color">open_in_new</mat-icon>
          </a>
        } @else {
            <a class="w-full flex flex-row bg-emphasis rounded-sm p-4 text-muted-color">
            <mat-icon>{{link.icon}}</mat-icon>
            <span class="ml-2">{{link.name}}</span>
            <mat-icon iconClass="ml-auto text-muted-color">open_in_new</mat-icon>
          </a>
        }
      }
    </nav>

    <!-- Status Cards -->
    <div id="status-cards" class="w-full grid grid-cols-4 gap-2 mt-8">
      <app-status-card
        class="w-full"
        [title]="'internal.dashboard.todosTitle' | translate"
        [value]="openTodos().length"
        [loading]="loadingTodos()"
        [disabled]="!api.hasPermission('view_todos')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
      />
      <app-status-card
        class="w-full"
        [title]="'internal.dashboard.requestsTitle' | translate"
        [value]="openRequests().length"
        [loading]="loadingRequests()"
        [disabled]="!api.hasPermission('view_requests')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
      />
      <app-status-card
        class="w-full"
        [title]="'internal.dashboard.inventoryTitle' | translate"
        [value]="openInventory().length"
        [loading]="loadingInventory()"
        [disabled]="!api.hasPermission('view_inventory')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
        [additionalLinkTitle]="'internal.dashboard.missingItems' | translate:{amount:missingItems()}"
      />
      <app-status-card
        class="w-full"
        [title]="'internal.dashboard.financesTitle' | translate"
        [value]="openFinances().length"
        [loading]="loadingFinances()"
        [disabled]="!api.hasPermission('view_finances')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
      />
    </div>

    <!-- List Cards -->
    <div id="list-cards" class="w-full grid grid-cols-2 gap-2 mt-8">
      <app-list-card
        class="w-full"
        [title]="'internal.dashboard.eventsTitle' | translate"
        [items]="eventItems()"
        [loading]="loadingEvents()"
        [disabled]="!api.hasPermission('view_events')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
        [additionalLinkTitle]="'internal.dashboard.eventsView' | translate"
        additionalLinkUrl="../events"
        [emptyText]="'internal.dashboard.eventsEmpty' | translate"
      />
      <app-list-card
        class="w-full"
        [title]="'internal.dashboard.todosTitle' | translate"
        [items]="todoItems()"
        [loading]="loadingTodos()"
        [disabled]="!api.hasPermission('view_todos')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
        [additionalLinkTitle]="'internal.dashboard.todosView' | translate"
        additionalLinkUrl="../todos"
        [emptyText]="'internal.dashboard.todosEmpty' | translate"
      />
      <app-list-card
        class="w-full"
        [title]="'internal.dashboard.inventoryTitle' | translate"
        [items]="inventoryItems()"
        [loading]="loadingInventory()"
        [disabled]="!api.hasPermission('view_inventory')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
        [additionalLinkTitle]="'internal.dashboard.inventoryView' | translate"
        additionalLinkUrl="../inventory"
        [emptyText]="'internal.dashboard.inventoryEmpty' | translate"
      />
      <app-list-card
        class="w-full"
        [title]="'internal.dashboard.financesTitle' | translate"
        [items]="financeItems()"
        [loading]="loadingFinances()"
        [disabled]="!api.hasPermission('view_finances')"
        [disabledText]="'internal.dashboard.noPermission' | translate"
        [additionalLinkTitle]="'internal.dashboard.financesView' | translate"
        additionalLinkUrl="../finances"
        [emptyText]="'internal.dashboard.financesEmpty' | translate"
      />
    </div>
  </div>
</div>